import api from "./configApi";

export const getSiteContents = async () => {
  try {
    const response = await api.get("/sitecontents");
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getSiteContent = async (id) => {
  try {
    const response = await api.get(`/sitecontents/${id}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const createSiteContent = async (siteContent) => {
  try {
    const response = await api.post("/sitecontents", siteContent);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateSiteContent = async (id, siteContent) => {
  try {
    const response = await api.put(`/sitecontents/${id}`, siteContent);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const deleteSiteContent = async (id) => {
  try {
    const response = await api.delete(`/sitecontents/${id}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};